import React, { useState, useEffect, useRef } from 'react';
import {
    Box, Typography, TextField, Button, Checkbox, FormControlLabel,
    Grid, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, IconButton, Autocomplete, Card, CardContent, Divider, MenuItem
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import Swal from 'sweetalert2';
import { db } from '../../firebase';
import { collection, addDoc, onSnapshot, query, where, updateDoc, doc, Timestamp, limit, getDocs, orderBy, writeBatch, getDoc } from 'firebase/firestore';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import { storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { uploadBytesResumable } from "firebase/storage";
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import { useParams } from "react-router-dom";

const EditTrip = () => {

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
    });

    const { id } = useParams();

    const [isAuto, setIsAuto] = useState(true);
    const [liveWeight, setLiveWeight] = useState(0);
    const [manualWeight, setManualWeight] = useState(0);

    const [grossWeight, setGrossWeight] = useState(0);
    const [tareWeight, setTareWeight] = useState(0);
    const [netWeight, setNetWeight] = useState(0);

    const [grossDate, setGrossDate] = useState(null);
    const [tareDate, setTareDate] = useState(null);


    const [selectedTripId, setSelectedTripId] = useState(null);

    const [creditLimit, setCreditLimit] = useState(0);
    const [remainingCredit, setRemainingCredit] = useState(0);
    const [usedCredit, setUsedCredit] = useState(0);

    const vehicleRef = useRef(null);
    const customerRef = useRef(null);

    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);
    const videoRef3 = useRef(null);

    const [productRows, setProductRows] = useState([
        { productId: '', productName: '', qty: 0, rate: 0, amount: 0 }
    ]);



    const [openProductDialog, setOpenProductDialog] = useState(false);

    const [tempProduct, setTempProduct] = useState({
        productId: "",
        productName: "",
        qty: 0,
        rate: 0,
        amount: 0
    });

    const handlePopupProduct = (value) => {

        const prod = products.find(p => p.name === value);

        setTempProduct({
            productId: prod?.id || "",
            productName: value,
            qty: 0,
            rate: prod?.rate || 0,
            amount: 0
        });

    };

    const handleTempChange = (field, value) => {
        const updated = { ...tempProduct, [field]: Number(value) };
        const amount = updated.qty * updated.rate;
        updated.amount = Math.round(amount); // round figure
        setTempProduct(updated);
    };

    const addProductFromPopup = () => {

        setProductRows(prev => [
            ...prev,
            tempProduct
        ]);

        setOpenProductDialog(false);

    };



    const handleProductChange = (index, value) => {
        const prod = products.find(p => p.name === value);

        let rate = 0;

        const selectedCustomer = customers.find(
            c => c.id === formData.customerId
        );

        // ✅ Get rate
        if (selectedCustomer && selectedCustomer.products) {
            const custProd = selectedCustomer.products.find(
                p => p.productName === value
            );

            if (custProd) {
                rate = custProd.rate;
            } else {
                rate = prod?.rate || 0;
            }
        } else {
            rate = prod?.rate || 0;
        }

        const rows = [...productRows];
        rows[index].productId = prod?.id || '';
        rows[index].productName = value;
        rows[index].rate = rate;
        rows[index].amount = Math.round((rows[index].qty || 0) * rate);

        setProductRows(rows);

        setFormData(prev => ({
            ...prev,
            type: prod?.tripType || "Sale" // default Sale
        }));
    };

    const handleRowChange = (index, field, value) => {
        const rows = [...productRows];
        rows[index][field] = Number(value);
        const amount = rows[index].qty * rows[index].rate;
        rows[index].amount = Math.round(amount); // round figure
        setProductRows(rows);
    };

    const totalSale = productRows.reduce((sum, row) => sum + row.amount, 0);

    const [formData, setFormData] = useState({
        customerId: '',
        customerName: '',
        vehicleNo: '',
        challan: '',
        mobile: '',
        location: '',
        wbName: 'Vishwajeet Khadi Kendra Bridge',
        ticketNo: '',
        paymentMode: '',
        type: "Sale",
        invoice: "No",
    });

    const [customers, setCustomers] = useState([]);
    const [products, setProducts] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [paymentModes, setPaymentModes] = useState([]);
    const [pendingTransactions, setPendingTransactions] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [productList, setProductList] = useState([]); // all products
    const [customerProducts, setCustomerProducts] = useState([
        { productId: "", productName: "", rate: 0 }
    ]);

    const currentDisplayWeight = isAuto ? liveWeight : (manualWeight || 0);

    useEffect(() => {
        onSnapshot(collection(db, "customers"), (s) => {
            setCustomers(s.docs.map(d => ({
                id: d.id,
                customerName: d.data().customerName,
                mobile: d.data().mobile || "",
                location: d.data().city || "",
                creditLimit: d.data().creditLimit || 0,
                products: d.data().products || []   // ✅ ADD THIS
            })));
        });

        onSnapshot(collection(db, "trip_products"), (s) => {
            setProducts(s.docs.map(d => ({
                id: d.id,
                name: d.data().productName,
                tripType: d.data().tripType,
                rate: d.data().rate || 0,

            })));
        });

        onSnapshot(collection(db, "vehicles"), (s) => {
            setVehicles(s.docs.map(d => d.data().vehicalNo || ""));
        });

        onSnapshot(collection(db, "payment_modes"), (s) => {
            setPaymentModes(s.docs.map(d => d.data().payMode || ""));
        });

        const q = query(collection(db, "trips"), where("status", "==", "Pending"), orderBy('tareDate', 'asc'));
        onSnapshot(q, (snapshot) => {
            setPendingTransactions(snapshot.docs.map(d => ({
                id: d.id,
                ...d.data()
            })));
        });
    }, []);

    // ---------------- CALCULATIONS ----------------
    useEffect(() => {
        const net = Math.max(0, (grossWeight || 0) - (tareWeight || 0));
        setNetWeight(net);
    }, [grossWeight, tareWeight]);

    useEffect(() => {
        const qty = Number(formData.brass || 0);
        const rate = Number(formData.rate || 0);

        setFormData(prev => ({
            ...prev,
            amount: qty * rate
        }));

    }, [formData.brass, formData.rate]);

    // useEffect(() => {
    //     if (window.electronAPI) {

    //         // connect automatically
    //         window.electronAPI.connectScale();

    //         window.electronAPI.onWeight((weight) => {
    //             console.log("Live Weight:", weight);
    //             setLiveWeight(weight);
    //         });
    //     }
    // }, []);

    // const handleConnect = () => {
    //     if (window.electronAPI) {

    //         // connect automatically
    //         window.electronAPI.connectScale();

    //         window.electronAPI.onWeight((weight) => {
    //             console.log("Live Weight:", weight);
    //             setLiveWeight(weight);
    //         });
    //     }
    // };

    useEffect(() => {
        if (!id) return;

        const fetchTrip = async () => {
            try {


                const tripRef = doc(db, "trips", id);
                const snap = await getDoc(doc(db, "trips", id));

                if (snap.exists()) {
                    const data = snap.data();
                    console.log(data);

                    // ✅ Set selectedTripId (important for edit mode)
                    setSelectedTripId(id);

                    // ✅ Set form data
                    setFormData({
                        customerId: data.customerId || "",
                        customerName: data.customerName || "",
                        vehicleNo: data.vehicleNo || "",
                        challan: data.challan || "",
                        mobile: data.mobile || "",
                        location: data.location || "",
                        wbName: data.wbName || "Vishwajeet Khadi Kendra Bridge",
                        ticketNo: data.ticketNo || "",
                        paymentMode: data.paymentMode || "",
                        type: data.type || "Sale",
                        invoice: data.invoice || "No",
                    });

                    // ✅ Weights
                    setTareWeight(data.tareWeight || 0);
                    setGrossWeight(data.grossWeight || 0);
                    setNetWeight(data.netWeight || 0);

                    // ✅ Dates
                    setTareDate(data.tareDate?.toDate() || null);
                    setGrossDate(data.grossDate?.toDate() || null);

                    // ✅ Products
                    setProductRows(
                        data.products?.length
                            ? data.products
                            : [{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]
                    );

                    // ✅ Credit
                    if (data.customerId) {
                        const cust = customers.find(c => c.id === data.customerId);
                        if (cust) {
                            setCreditLimit(cust.creditLimit || 0);
                            calculateCustomerCredit(data.customerId, cust.creditLimit);
                        }
                    }

                } else {
                    Swal.fire("Error", "Trip not found", "error");
                }

            } catch (err) {
                console.error(err);
                Swal.fire("Error", "Failed to fetch trip", "error");
            }
        };

        fetchTrip();
    }, [id, customers]);



    const handleCapture = async () => {
        const currentWeight = isAuto ? liveWeight : manualWeight;

        if (!selectedTripId) {
            // ----- TARE -----
            setTareWeight(currentWeight);
            setTareDate(new Date());

            const photos = await Promise.all([
                capturePhoto(videoRef1, "tare", 1),
                capturePhoto(videoRef2, "tare", 2),
                capturePhoto(videoRef3, "tare", 3),
            ]);

            const tarePhotoUrls = await savePhotos(photos);
            console.log("Tare Photos Saved:", tarePhotoUrls);
            vehicleRef.current?.focus();
            // Optionally store in Firestore under new trip
            // const tripRef = await addDoc(collection(db, "trips"), { tarePhotos: tarePhotoUrls, tareWeight: currentWeight, ... });

        } else {
            // ----- GROSS -----
            setGrossWeight(currentWeight);
            setGrossDate(new Date());

            const photos = await Promise.all([
                capturePhoto(videoRef1, "gross", 1),
                capturePhoto(videoRef2, "gross", 2),
                capturePhoto(videoRef3, "gross", 3),
            ]);

            const grossPhotoUrls = await savePhotos(photos);
            console.log("Gross Photos Saved:", grossPhotoUrls);

            customerRef.current?.focus();

            // Optionally update existing trip
            // const tripRef = doc(db, "trips", selectedTripId);
            // await updateDoc(tripRef, { grossPhotos: grossPhotoUrls, grossWeight: currentWeight });
        }
    };

    const handleProcess = async () => {
        // ----------------- Basic Validation -----------------
        if (!formData.vehicleNo) {
            Swal.fire("Error", "Please fill all required fields", "error");
            return;
        }
        try {
            if (!formData.customerName) {
                Swal.fire("Error", "Customer name required", "error");
                return;
            }
            if (!formData.vehicleNo) {
                Swal.fire("Error", "Vehicle number required", "error");
                return;
            }

            const [customer, vehicleId] = await Promise.all([
                getOrCreateCustomer(formData),
                // getOrCreateVehicle(formData.vehicleNo)
            ]);

            const updatedFormData = {
                ...formData,
                customerId: customer.id,
                customerName: customer.data.customerName,
                vehicleId: formData.vehicleNo,
            };

            const tripCollection =
                formData.type === "Purchase" ? "trips" : "trips";

            // ----------------- First Entry (Tare) -----------------
            if (!selectedTripId && !id) {
                const tareTime = Timestamp.now();
                const nextTicket = await generateTicketNo();
                // ================= EDIT MODE =================
                if (id) {
                    const tripRef = doc(db, tripCollection, id);
                    await updateDoc(tripRef, {
                        ...updatedFormData,
                        products: productRows,
                        totalAmount: totalSale,
                        grossWeight,
                        tareWeight,
                        netWeight,
                        updatedAt: Timestamp.now(),
                        paidAmount: 0,
                        remainingAmount: totalSale,
                    });

                    Swal.fire("Updated", "Trip updated successfully", "success");
                    return;
                }
                // Create trip document
                const tripRef = await addDoc(collection(db, tripCollection), {
                    ...updatedFormData,
                    ticketNo: nextTicket,
                    products: productRows,
                    totalAmount: totalSale,
                    tareWeight: tareWeight,
                    grossWeight: grossWeight,
                    tareDate: tareTime,
                    status: "Pending",
                    paidAmount: 0,
                    remainingAmount: totalSale,
                });

                setFormData(prev => ({ ...prev, ticketNo: nextTicket }));
                setTareDate(tareTime.toDate());
                captureAllPhotos(tripRef.id, "tare").then(async (urls) => {
                    await updateDoc(tripRef, { tarePhotos: urls });
                });
                clearForm();
                Swal.fire("Success", "Tare weight saved successfully", "success");
            }
            // ----------------- Second Entry (Gross / Completion) -----------------
            else {
                // Validation
                if (!formData.customerId) {
                    Swal.fire("Error", "Customer is required", "error");
                    return;
                }
                if (!formData.vehicleNo || formData.vehicleNo.trim() === "") {
                    Swal.fire("Error", "Vehicle number is required", "error");
                    return;
                }
                if (!productRows || productRows.length === 0) {
                    Swal.fire("Error", "At least one product must be added", "error");
                    return;
                }
                const [customer, vehicleId] = await Promise.all([
                    getOrCreateCustomer(formData),
                    // getOrCreateVehicle(formData.vehicleNo)
                ]);

                const tripRef = doc(db, tripCollection, selectedTripId);
                const finalGross = grossWeight || currentDisplayWeight;
                const net = Math.max(0, finalGross - tareWeight);

                await checkVehicleWeightAlert(formData.vehicleNo, net);

                const grossImagesPromise = captureAllPhotos(selectedTripId, "gross");

                const updatedFormData = {
                    ...formData,
                    customerId: customer.id,
                    customerName: customer.data.customerName,
                    vehicleId: formData.vehicleNo,
                };
                // Commit trip update and ledger together in batch for speed
                const batch = writeBatch(db);
                batch.update(tripRef, {
                    ...updatedFormData,
                    products: productRows,
                    grossWeight: grossWeight,
                    tareWeight: tareWeight,
                    netWeight: netWeight,
                    status: "Completed",
                    paidAmount: 0,
                    remainingAmount: totalSale,
                     totalAmount: totalSale,
                });
                await batch.commit();

                // Whatsapp Integration 

                try {
                    const invoiceData = {
                        customerName: formData.customerName,
                        mobile: formData.mobile,
                        vehicleNo: formData.vehicleNo,
                        ticketNo: formData.ticketNo,
                        challan: formData.challan,
                        products: productRows
                    };

                    const pdfBlob = await pdf(
                        <InvoicePDF invoiceData={invoiceData} />
                    ).toBlob();

                    const storageRef = ref(storage, `invoices/invoice_${Date.now()}.pdf`);
                    const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

                    uploadTask.on(
                        "state_changed",
                        null,
                        (error) => console.error(error),
                        async () => {
                            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

                            // ✅ Calculate fresh credit
                            const creditData = await calculateCustomerCreditLive(
                                customer.id,
                                creditLimit
                            );

                            const latestRemaining = creditData.remaining;
                            // ✅ CALL HERE
                            // await sendWhatsAppMessage(
                            //     formData.mobile,
                            //     downloadURL,
                            //     formData.customerName,
                            //     formData.ticketNo,
                            //     totalSale,
                            //     productRows,          // ✅ pass products
                            //     latestRemaining || 0  // ✅ outstanding
                            // );
                        }
                    );
                } catch (error) {
                    console.error("Error generating/uploading PDF:", error);
                }

                // setGrossDate(grossTime.toDate());
                Swal.fire("Completed", "Transaction processed and ledger updated", "success");
                setCreditLimit(0);
                setRemainingCredit(0);
                setUsedCredit(0);
                const grossImages = await grossImagesPromise;
                await updateDoc(tripRef, { grossPhotos: grossImages });
                clearForm();

            }
        } catch (e) {
            Swal.fire("Error", "Transaction failed: " + e.message, "error");
        }
    };

    const calculateCustomerCreditLive = async (custId, limit) => {

        const tripQuery = query(
            collection(db, "trips"),
            where("customerId", "==", custId)
        );

        const tripSnap = await getDocs(tripQuery);

        let totalSale = 0;

        tripSnap.forEach(doc => {
            const data = doc.data();
            const tripTotal = data.products?.reduce(
                (sum, p) => sum + Number(p.amount || 0),
                0
            ) || 0;

            totalSale += tripTotal;
        });

        // Payments
        const payQuery = query(
            collection(db, "customer_history"),
            where("customerId", "==", custId)
        );

        const paySnap = await getDocs(payQuery);

        let totalPaid = 0;

        paySnap.forEach(doc => {
            totalPaid += Number(doc.data().amount || 0);
        });

        const used = totalSale - totalPaid;
        const remaining = used;

        return {
            used,
            remaining
        };
    };


    const getOrCreateVehicle = async (vehicleNo) => {
        const vehicleRef = collection(db, "vehicles");

        const q = query(vehicleRef, where("vehicalNo", "==", vehicleNo));
        const snap = await getDocs(q);

        if (!snap.empty) {
            return snap.docs[0].id;
        }

        // ❌ Not found → create new vehicle
        const newVehicle = {
            type: "Tipper",
            vehicalNo: vehicleNo,
            puc: "",
            insurance: "",
            pucDate: "",
            insuranceDate: "",
            createdAt: Timestamp.now(),
        };

        const docRef = await addDoc(vehicleRef, newVehicle);

        return docRef.id;
    };


    const fetchProductDetails = async (productId) => {
        const q = query(
            collection(db, "tripProducts"),
            where("__name__", "==", productId)
        );

        const snap = await getDocs(q);

        if (!snap.empty) {
            return snap.docs[0].data();
        }

        return null;
    };

    const getOrCreateCustomer = async (formData) => {
        const customersRef = collection(db, "customers");

        let q;

        if (formData.mobile) {
            q = query(customersRef, where("mobile", "==", formData.mobile));
        } else {
            q = query(customersRef, where("customerName", "==", formData.customerName));
        }

        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
            const docSnap = snapshot.docs[0];
            return { id: docSnap.id, data: docSnap.data() };
        }

        // CREATE NEW
        const newCustomer = {
            customerName: formData.customerName || "",
            mobile: formData.mobile || "",
            address: formData.location || "",
            city: formData.location || "",
            createdAt: Timestamp.now(),
        };

        const docRef = await addDoc(customersRef, newCustomer);
        handlePartySelect(newCustomer);
        return { id: docRef.id, data: newCustomer };
    };

    const handlePartySelect = async (value) => {

        const cust = customers.find(c => c.customerName === value);
        if (!cust) return;

        setFormData(prev => ({
            ...prev,
            customerId: cust.id,
            customerName: cust.customerName,
            mobile: cust.mobile,
            location: cust.location
        }));

        setCreditLimit(cust.creditLimit || 0);

        calculateCustomerCredit(cust.id, cust.creditLimit);
    };

    const calculateCustomerCredit = async (custId, limit) => {

        const tripQuery = query(
            collection(db, "trips"),
            where("customerId", "==", custId)
        );

        const tripSnap = await getDocs(tripQuery);
        let totalSale = 0;
        tripSnap.forEach(doc => {
            const data = doc.data();
            const tripTotal = data.products?.reduce(
                (sum, p) => sum + Number(p.amount || 0),
                0
            ) || 0;

            totalSale += tripTotal;
        });
        // GET PAYMENTS
        const payQuery = query(
            collection(db, "customer_history"),
            where("customerId", "==", custId)
        );

        const paySnap = await getDocs(payQuery);
        let totalPaid = 0;
        paySnap.forEach(doc => {

            const data = doc.data();

            totalPaid += Number(data.amount || 0);

        });

        const used = totalSale - totalPaid;
        const remaining = limit - used;

        setUsedCredit(used);
        setRemainingCredit(remaining);
    };


    const clearForm = () => {

        setFormData({
            customerId: "",
            customerName: "",
            vehicleNo: "",
            challan: "",
            mobile: "",
            location: "",
            wbName: "Vishwajeet Khadi Kendra Bridge",
            ticketNo: "",
            paymentMode: ""
        });

        // Reset Product Rows
        setProductRows([
            { productId: "", productName: "", qty: 0, rate: 0, amount: 0 }
        ]);

        setGrossWeight(0);
        setTareWeight(0);
        setNetWeight(0);

        setGrossDate(null);
        setTareDate(null);

        setSelectedTripId(null);
        setManualWeight(0);
    };

    const formatDate = (d) => {
        if (!d) return "";
        return new Date(d).toLocaleString();
    };

    const generateTicketNo = async () => {

        const q = query(
            collection(db, "trips"),
            orderBy("ticketNo", "desc"),
            limit(1)
        );

        const snap = await getDocs(q);

        if (snap.empty) {
            return 1;
        }

        const lastTicket = snap.docs[0].data().ticketNo || 0;

        return lastTicket + 1;
    };

    const startCameras = async () => {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const cameras = devices.filter(d => d.kind === "videoinput");
        console.log("Cameras:", cameras);

        if (cameras.length === 0) {
            alert("No cameras found!");
            return;
        }

        if (cameras[0]) {
            const stream1 = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameras[0].deviceId } });
            videoRef1.current.srcObject = stream1;
        }

        if (cameras[1]) {
            const stream2 = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameras[1].deviceId } });
            videoRef2.current.srcObject = stream2;
        }

        if (cameras[2]) {
            const stream3 = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameras[2].deviceId } });
            videoRef3.current.srcObject = stream3;
        }
    };

    useEffect(() => {
        startCameras();
    }, [])

    const capturePhoto = async (videoRef, type, cameraIndex) => {
        if (!videoRef.current) return null;

        const canvas = document.createElement("canvas");
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        const blob = await new Promise(resolve =>
            canvas.toBlob(resolve, "image/jpeg", 0.9)
        );

        return { blob, fileName: `${type}_cam${cameraIndex}_${Date.now()}.jpg` };
    };


    const captureAllPhotos = async (tripId, type) => {
        // Capture all blobs first
        const blobs = await Promise.all([
            capturePhoto(videoRef1, type, 1),
            capturePhoto(videoRef2, type, 2),
            capturePhoto(videoRef3, type, 3),
        ]);

        // Upload all in parallel
        const uploadPromises = blobs.map((photo, index) => {
            if (!photo) return null;
            const storageRef = ref(storage, `trips/${tripId}/${photo.fileName}`);
            return uploadBytes(storageRef, photo.blob).then(() => getDownloadURL(storageRef));
        });

        const urls = await Promise.all(uploadPromises);

        return urls.filter(u => u !== null); // Remove any nulls
    };

    const savePhotos = async (photos) => {
        const urls = [];
        for (const photo of photos) {
            if (!photo) continue;
            const storageRef = ref(storage, `weighbridge/${photo.fileName}`);
            await uploadBytes(storageRef, photo.blob);
            const url = await getDownloadURL(storageRef);
            urls.push(url);
        }
        return urls;
    };

    const fetchCustomerFromVehicle = async (vehicleNo) => {
        try {
            const q = query(
                collection(db, "trips"),
                where("vehicleNo", "==", vehicleNo),
                orderBy("tareDate", "desc"),
                where("customerId", "!=", ""),
                limit(1)
            );

            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const data = snapshot.docs[0].data();

                console.log("Vehicle matched customer:", data);

                setFormData(prev => ({
                    ...prev,
                    customerId: data.customerId || "",
                    customerName: data.customerName || "",
                    mobile: data.mobile || "",
                    location: data.location || ""
                }));

                // 🔥 Also update credit
                if (data.customerId) {
                    const cust = customers.find(c => c.id === data.customerId);

                    if (cust) {
                        setCreditLimit(cust.creditLimit || 0);
                        calculateCustomerCredit(cust.id, cust.creditLimit);
                    }
                }

            } else {
                console.log("No previous trip found for this vehicle");
            }

        } catch (err) {
            console.log("Error fetching vehicle data:", err);
        }
    };

    const checkVehicleWeightAlert = async (vehicleNo, currentNetWeight) => {
        try {
            const q = query(
                collection(db, "trips"),
                where("vehicleNo", "==", vehicleNo),
                orderBy("tareDate", "desc"),
                limit(6)
            );

            const snap = await getDocs(q);

            if (snap.empty) return;

            const weights = snap.docs.map(d => {
                const data = d.data();
                return Number(data.netWeight || 0);
            });

            console.log("Last Weights:", weights);

            // ==============================
            // 🚨 CASE 1: LESS THAN 3 TRIPS
            // ==============================
            if (weights.length < 2) {

                await addDoc(collection(db, "weight_alerts"), {
                    vehicleNo,
                    previousWeights: weights,
                    currentWeight: currentNetWeight,
                    type: "NEW_VEHICLE_ALERT",
                    reason: "Less than 3 trips data",
                    createdAt: Timestamp.now(),
                    status: 'Unread',
                });

                Toast.fire({
                    icon: "warning",
                    title: `⚠️ ${vehicleNo} | New Vehicle / Low History`
                });

                return;
            }

            // ==============================
            // 🚨 CASE 2: NORMAL HIGH CHECK
            // ==============================

            const avgWeight =
                weights.reduce((sum, w) => sum + w, 0) / weights.length;

            const MAX_ALLOWED_DIFF = 500;

            if (currentNetWeight > avgWeight + MAX_ALLOWED_DIFF) {

                const diff = currentNetWeight - avgWeight;

                await addDoc(collection(db, "weight_alerts"), {
                    vehicleNo,
                    previousWeights: weights,
                    averageWeight: avgWeight,
                    currentWeight: currentNetWeight,
                    difference: diff,
                    type: "HIGH_ALERT 🚨",
                    createdAt: Timestamp.now(),
                    status: 'Unread',

                });

                Toast.fire({
                    icon: "error",
                    title: `🚨 ${vehicleNo} | ${currentNetWeight} kg (+${diff.toFixed(0)})`
                });
            }

        } catch (err) {
            console.log("Weight Alert Error:", err);
        }
    };


    const sendWhatsAppMessage = async (
        mobile,
        downloadURL,
        customerName,
        invoiceNo,
        amount,
        products = [],
        outstanding = 0
    ) => {
        try {
            const wabaid = "1092943420558604";
            const accesstoken = "EAAKj5T0Mx1YBRNd6VhhufPP2ApIjZCsZBFOkl855np9VZBvPvZAZAj7axVAevZBiapxd1Iw38v0hhZBwB2knNeLYSVgjR3RqtPn164H2GQ3ljP46kQvAAq0gsl3lfKDh55ZCsmo5fGZCaUSPpCRqeFjVA6VUeIaiu0ZCNxPPMTsV4oxnnUz4TRoICdbiW0xsAncwZDZD";

            // ✅ Extract values from products
            const productNames = products.map(p => p.productName).join(", ");
            const totalQty = products.reduce((sum, p) => sum + Number(p.qty || 0), 0);
            const rate = products[0]?.rate || 0;

            const todayDate = new Date().toLocaleDateString("en-IN");

            const payload = {
                messaging_product: "whatsapp",
                to: "91" + mobile,
                type: "template",
                template: {
                    name: "trip_invoice",
                    language: { code: "en" },
                    components: [
                        {
                            type: "header",
                            parameters: [
                                {
                                    type: "document",
                                    document: {
                                        link: downloadURL,
                                        filename: "Invoice.pdf"
                                    }
                                }
                            ]
                        },
                        {
                            type: "body",
                            parameters: [
                                { type: "text", text: customerName },                 // {{1}}
                                { type: "text", text: productNames || "-" },          // {{2}}
                                { type: "text", text: totalQty.toString() },          // {{3}}
                                { type: "text", text: rate.toString() },              // {{4}}
                                { type: "text", text: amount.toString() },            // {{5}}
                                { type: "text", text: todayDate },                    // {{6}}
                                { type: "text", text: outstanding.toString() }        // {{7}}
                            ]
                        }
                    ]
                }
            };

            const response = await fetch(`https://graph.facebook.com/v22.0/${wabaid}/messages`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`
                },
                body: JSON.stringify(payload)
            });


            const data = await response.json();
            if (response.ok) {
                console.log("✅ WhatsApp Sent:", data);
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, customerName, invoiceNo, type: "Trip Invoice", amount, fileURL: downloadURL, status: "Sent", createdAt: Timestamp.now() });
                Toast.fire({ icon: "success", title: "WhatsApp Invoice Sent" });
            }
            else {
                console.error("❌ WhatsApp Error:", data);
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, customerName, invoiceNo, type: "Trip Invoice", amount, fileURL: downloadURL, status: "Failed", error: data.error?.message, createdAt: Timestamp.now() });
            }



        } catch (error) {
            console.error("❌ Fetch Error:", error);
        }
    };

    const InvoicePDF = ({ invoiceData }) => {

        const products = invoiceData.products || [];

        const totalSale = products.reduce(
            (sum, item) => sum + Number(item.amount || 0),
            0
        );

        return (
            <Document>
                <Page size="A4" style={styles.page}>

                    {/* HEADER */}
                    <View style={styles.headerBox}>
                        <Text style={styles.company}>Vishwajeet Khadi Kendra INFRA DHARASHIV PVT LTD</Text>
                        <Text style={styles.sub}>Dharashiv, Maharashtra</Text>
                        <Text style={styles.sub}> +91 75076 01020</Text>
                    </View>

                    {/* INVOICE TITLE */}
                    <View style={styles.invoiceTitleBox}>
                        <Text style={styles.invoiceTitle}>TRIP INVOICE</Text>
                    </View>

                    {/* DETAILS */}
                    <View style={styles.detailsWrapper}>

                        <View style={styles.detailsCard}>
                            <Text style={styles.cardTitle}>Customer Details</Text>

                            <View style={styles.row}>
                                <Text style={styles.label}>Name</Text>
                                <Text style={styles.value}>{invoiceData.customerName || "-"}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Mobile</Text>
                                <Text style={styles.value}>{invoiceData.mobile || "-"}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Vehicle</Text>
                                <Text style={styles.value}>{invoiceData.vehicleNo || "-"}</Text>
                            </View>
                        </View>

                        <View style={styles.detailsCard}>
                            <Text style={styles.cardTitle}>Trip Details</Text>

                            <View style={styles.row}>
                                <Text style={styles.label}>Ticket No</Text>
                                <Text style={styles.value}>{invoiceData.ticketNo}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>HCL No</Text>
                                <Text style={styles.value}>{invoiceData.challan || "-"}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Date</Text>
                                <Text style={styles.value}>
                                    {new Date().toLocaleDateString()}
                                </Text>
                            </View>
                        </View>

                    </View>

                    {/* TABLE */}
                    <View style={styles.tableBox}>

                        <View style={styles.tableHeader}>
                            <Text style={{ width: '10%' }}>#</Text>
                            <Text style={{ width: '35%' }}>Product</Text>
                            <Text style={{ width: '15%', textAlign: 'right' }}>Qty</Text>
                            <Text style={{ width: '20%', textAlign: 'right' }}>Rate</Text>
                            <Text style={{ width: '20%', textAlign: 'right' }}>Amount</Text>
                        </View>

                        {products.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <Text style={{ width: '10%' }}>{index + 1}</Text>
                                <Text style={{ width: '35%' }}>{item.productName}</Text>
                                <Text style={{ width: '15%', textAlign: 'right' }}>{item.qty}</Text>
                                <Text style={{ width: '20%', textAlign: 'right' }}>{item.rate}</Text>
                                <Text style={{ width: '20%', textAlign: 'right' }}>{item.amount}</Text>
                            </View>
                        ))}

                    </View>

                    {/* TOTAL */}
                    <View style={styles.totalSection}>
                        <Text style={styles.totalLabel}>TOTAL SALE</Text>
                        <Text style={styles.totalValue}> {totalSale.toFixed(2)}</Text>
                    </View>

                    {/* FOOTER */}
                    <View style={styles.footerBox}>
                        <Text style={styles.footer}>Thank you for your business </Text>
                    </View>

                </Page>
            </Document>
        );
    };

    return (
        <Box
            sx={{
                bgcolor: '#f4f6f8',
                minHeight: '100vh',
                "& .MuiInputBase-root": {
                    fontSize: "14px"
                },

                "& .MuiTableCell-root": {
                    fontSize: "13px",
                    padding: "6px 6px"
                },

                "& .MuiButton-root": {
                    fontSize: "11px",
                    padding: "4px 8px"
                }
            }}
        >
            <Grid className="row" spacing={2} sx={{ display: 'flex' }}>
                {/* LEFT COLUMN */}
                <Grid className="col-sm-3" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper elevation={3} sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                             {/*<FormControlLabel control={<Checkbox size="small" checked={isAuto} onChange={(e) => setIsAuto(e.target.checked)} />} label="Auto" />
                            <Button size="small" onClick={handleConnect}>Connect COM</Button> */}
                        </Box>

                        <Box sx={{
                            bgcolor: 'black', color: '#ff1744', textAlign: 'center', fontSize: '3.5rem',
                            fontWeight: 'bold', fontFamily: 'monospace', borderRadius: 2, mb: 2, border: '2px solid #333',
                        }}
                        >
                            {isAuto ? liveWeight : (
                                <TextField variant="standard" type="number" value={manualWeight} onChange={(e) => setManualWeight(Number(e.target.value))} inputProps={{ style: { color: '#ff1744', fontSize: '3rem', textAlign: 'center', fontFamily: 'monospace' } }} InputProps={{ disableUnderline: true }} />
                            )}
                        </Box>

                        <Button
                            fullWidth disabled
                            variant="contained"
                            color="secondary"
                            onClick={handleCapture}
                        >
                            Capture {selectedTripId ? "Gross" : "Tare"}
                        </Button>


                        <Card sx={{ mb: 1, borderRadius: 2, boxShadow: 4, mt: 1 }}>
                            <CardContent>

                                <Grid className="row" spacing={1} >
                                    <Grid className="col-sm-5 mb-2">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>WB Name</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={formData.wbName} onChange={(e) => setFormData({ ...formData, wbName: e.target.value })} />
                                    </Grid>

                                    <Grid className="col-sm-5">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Ticket No</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7">
                                        <TextField fullWidth size="small" value={formData.ticketNo} onChange={(e) => setFormData({ ...formData, ticketNo: e.target.value })} />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card sx={{ mb: 1, borderRadius: 2, boxShadow: 4 }}>
                            <CardContent>

                                <Grid className="row" spacing={1} >
                                    <Grid className="col-sm-5 mb-2">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Gross Weight</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={grossWeight} onChange={(e) => setGrossWeight(Number(e.target.value))} />
                                    </Grid>

                                    <Grid className="col-sm-5 mb-2">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Tare Weight</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={tareWeight} onChange={(e) => setTareWeight(Number(e.target.value))} />
                                    </Grid>

                                    <Grid className="col-sm-5 ">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Net Weight</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 ">
                                        <TextField fullWidth size="small" value={netWeight} disabled />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Box display="flex" flexDirection="column" gap={1}>
                            {/* Gross Date Row */}
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                p={1}
                                bgcolor="#e3f2fd"
                                borderRadius={1}
                            >
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                                    Gross Date
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#0d47a1' }}>
                                    {formatDate(grossDate)}
                                </Typography>
                            </Box>

                            {/* Tare Date Row */}
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                p={1}
                                bgcolor="#fce4ec"
                                borderRadius={1}
                            >
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#c2185b' }}>
                                    Tare Date
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#880e4f' }}>
                                    {formatDate(tareDate)}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>

                {/* MIDDLE COLUMN */}
                <Grid className="col-sm-5" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper elevation={3} sx={{ p: 2, flex: 1 }}>
                        <Box className="row" sx={{ mt: 1, p: 1, bgcolor: "#fff3e0", borderRadius: 1, mb: 1 }}>
                            <Typography className='col-sm-4' fontSize={13}>
                                Credit Limit : ₹ {creditLimit}
                            </Typography>

                            <Typography className='col-sm-4' fontSize={13}>
                                Used Credit : ₹ {usedCredit}
                            </Typography>

                            <Typography className='col-sm-4' fontSize={13}
                                sx={{
                                    color: remainingCredit < 0 ? "red" : "green",
                                    fontWeight: "bold"
                                }}
                            >
                                Remaining  : ₹ {remainingCredit}
                            </Typography>
                        </Box>

                        <Grid className="row" spacing={1}>

                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Vehicle No</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <Autocomplete
                                    freeSolo autoFocus
                                    size="small"
                                    options={vehicles}
                                    value={formData.vehicleNo || ""}
                                    onChange={(e, val) => {
                                        setFormData({ ...formData, vehicleNo: val || "" });
                                        if (val) fetchCustomerFromVehicle(val);
                                    }}
                                    onInputChange={(e, val) => setFormData({ ...formData, vehicleNo: val })}
                                    renderInput={(params) => <TextField {...params} fullWidth inputRef={vehicleRef} />}
                                />
                            </Grid>


                            {/* Customer */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Customer</Typography>
                            </Grid>


                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <Autocomplete
                                    freeSolo
                                    size="small"
                                    options={customers.map(c => c.customerName)}
                                    value={formData.customerName || ""}
                                    onChange={(e, val) => handlePartySelect(val)}
                                    onInputChange={(e, val) => setFormData({ ...formData, customerName: val })}
                                    renderInput={(params) => <TextField {...params} fullWidth inputRef={vehicleRef} />}
                                />
                            </Grid>

                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Product</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <Autocomplete
                                    size="small"
                                    options={products.map(p => p.name)}
                                    value={productRows[0]?.productName || ""}
                                    onChange={(e, val) => handleProductChange(0, val)}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </Grid>

                            {/* Challan */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Challan</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={formData.challan}
                                    onChange={(e) => setFormData({ ...formData, challan: e.target.value })}
                                />
                            </Grid>

                            {/* Brass / Qty */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Brass</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    type="number"
                                    fullWidth
                                    value={productRows[0]?.qty}
                                    onChange={(e) => handleRowChange(0, "qty", e.target.value)}
                                />
                            </Grid>

                            {/* Rate */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Rate</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    type="number"
                                    fullWidth
                                    value={productRows[0]?.rate}
                                    onChange={(e) => handleRowChange(0, "rate", e.target.value)}
                                />
                            </Grid>

                            {/* Amount */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Amount</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    disabled
                                    value={productRows[0]?.amount}
                                />
                            </Grid>

                            {/* Mobile */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Mobile</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={formData.mobile}
                                    onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                                />
                            </Grid>

                            {/* Location */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Location</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={formData.location}
                                    onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                                />
                            </Grid>


                        </Grid>

                        {productRows.slice(1).map((row, index) => (

                            <Box
                                key={index}
                                sx={{
                                    border: "1px solid #ddd",
                                    p: 1,
                                    borderRadius: 1,
                                    mt: 1
                                }}
                            >

                                <Typography fontWeight="bold">
                                    {row.productName}
                                </Typography>

                                <Grid container spacing={1}>

                                    <Grid item xs={4}>
                                        Qty : {row.qty}
                                    </Grid>

                                    <Grid item xs={4}>
                                        Rate : ₹{row.rate}
                                    </Grid>

                                    <Grid item xs={4}>
                                        Amount : ₹{row.amount}
                                    </Grid>

                                </Grid>

                            </Box>

                        ))}

                        <Box display="flex" gap={1} mt={2}>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleProcess}
                                startIcon={<RefreshIcon />}
                                sx={{ flex: 1 }}>
                                {selectedTripId ? "Update" : "Save Tare"}
                            </Button>

                            <Button
                                variant="contained"
                                color="error"
                                onClick={clearForm}
                                sx={{ flex: 1 }}
                            >
                                <CancelIcon /> Cancel
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={() => window.print()}
                                sx={{ flex: 1 }}
                            >
                                <PrintIcon /> Print
                            </Button>
                        </Box>

                        <Box display="flex" justifyContent="space-between" gap={1} mt={2}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setOpenProductDialog(true)}
                            >
                                ➕ Add Product
                            </Button>

                            <Typography sx={{ fontWeight: "bold", fontSize: "24px" }}>
                                Total Sale : ₹ {totalSale}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>

                <Grid className="col-sm-4" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper
                        elevation={3}
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%" // important
                        }}
                    >
                        {/* HEADER */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} p={1}>
                            <Typography variant="button" color="primary">
                                Pending Transactions
                            </Typography>
                            <IconButton size="small">
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        {/* TABLE SCROLL AREA */}

                        {/* ✅ STICKY BUTTONS */}
                        {/* <Box
                            sx={{
                                position: "sticky",
                                bottom: 0,
                                background: "#fff",
                                p: 1,
                                borderTop: "1px solid #ddd",
                                zIndex: 10
                            }}
                        >
                            <Box display="flex" gap={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{ flex: 1 }} onClick={() => setOpenDialog(true)}
                                >
                                    Add Customer
                                </Button>

                                <Button
                                    variant="contained"
                                    color="warning"
                                    sx={{ flex: 1 }}
                                >
                                    Add Vehicles
                                </Button>


                            </Box>
                        </Box> */}
                    </Paper>
                </Grid>
                <Box className="row" mt={2}>
                    <video className='col-sm-4' ref={videoRef1} autoPlay playsInline muted />
                    <video className='col-sm-4' ref={videoRef2} autoPlay playsInline muted />
                    <video className='col-sm-4' ref={videoRef3} autoPlay playsInline muted />
                </Box>
            </Grid>

            <Dialog open={openProductDialog} onClose={() => setOpenProductDialog(false)}>

                <DialogTitle>Add Product</DialogTitle>

                <DialogContent>

                    <Autocomplete
                        size="small"
                        options={products.map(p => p.name)}
                        onChange={(e, v) => handlePopupProduct(v)}
                        renderInput={(params) => <TextField {...params} label="Product" />}
                    />

                    <TextField
                        fullWidth
                        label="Qty"
                        size="small"
                        type="number"
                        sx={{ mt: 2 }}
                        value={tempProduct.qty}
                        onChange={(e) => handleTempChange("qty", e.target.value)}
                    />

                    <TextField
                        size="small"
                        fullWidth
                        label="Rate"
                        type="number"
                        sx={{ mt: 2 }}
                        value={tempProduct.rate}
                        onChange={(e) => handleTempChange("rate", e.target.value)}
                    />

                    <TextField
                        fullWidth size='small'
                        label="Amount"
                        type="number"
                        sx={{ mt: 2 }}
                        value={tempProduct.amount}
                        disabled
                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => setOpenProductDialog(false)}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={addProductFromPopup}
                    >
                        Add
                    </Button>

                </DialogActions>

            </Dialog>


        </Box>
    );
};
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: 'Helvetica',
        fontSize: 10
    },

    headerBox: {
        textAlign: 'center',
        borderBottomWidth: 2,
        borderBottomColor: '#000',
        paddingBottom: 8,
        marginBottom: 10
    },
    company: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    sub: {
        fontSize: 10
    },

    invoiceTitleBox: {
        alignItems: 'center',
        marginVertical: 10
    },
    invoiceTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        borderBottomWidth: 1,
        paddingBottom: 4
    },

    detailsWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12
    },
    detailsCard: {
        width: '48%',
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 6,
        padding: 8
    },
    cardTitle: {
        fontSize: 11,
        fontWeight: 'bold',
        marginBottom: 5,
        borderBottomWidth: 1,
        paddingBottom: 3
    },

    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 4
    },

    label: {
        fontSize: 9,
        color: '#555'
    },
    value: {
        fontSize: 10,
        fontWeight: 'bold'
    },

    tableBox: {
        borderWidth: 1,
        borderColor: '#ccc',
        marginTop: 5
    },

    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f0f0f0',
        padding: 6,
        fontWeight: 'bold',
        borderBottomWidth: 1
    },

    tableRow: {
        flexDirection: 'row',
        padding: 6,
        borderBottomWidth: 0.5,
        borderBottomColor: '#ddd'
    },

    totalSection: {
        marginTop: 10,
        padding: 10,
        borderTopWidth: 2,
        alignItems: 'flex-end'
    },
    totalLabel: {
        fontSize: 11,
        fontWeight: 'bold'
    },
    totalValue: {
        fontSize: 14,
        fontWeight: 'bold'
    },

    footerBox: {
        marginTop: 20,
        alignItems: 'center'
    },
    footer: {
        fontSize: 10,
        color: '#555'
    }
});

export default EditTrip;